import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type RefreshState = {
  refresh: boolean;
}

const initialState: RefreshState = {
  refresh: false,
};

const refreshSlice = createSlice({
  name: 'refresh',
  initialState,
  reducers: {
    setRefresh: (state, action: PayloadAction<boolean>) => {
      state.refresh = action.payload;
    },
  },
});

export const { setRefresh } = refreshSlice.actions;
export default refreshSlice;
